module.exports = __webpack_public_path__ + "static/media/2018.67cab17e.png";